import yup from '../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getReportFormValidation(t: TFunction) {
  return yup.object({
    message: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '4096'))
      .required(t('formikValidation.messageRequired')),
    status: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.lastnameRequired')),
  });
}
